module.exports = __webpack_public_path__ + "img/background.3a4e2d7e.png";